<template>
  <b-card>
    <b-row>
      <b-col>
        <h6>{{ $t('views.technicians.index.filtering') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="5">
        <b-row>
          <b-col>
            <div class="form-group">
              <label class="form-control-label">{{ $t('views.technicians.index.filters.status') }}</label>
              <el-select
                v-model="filters.status"
                multiple
                filterable
                remote
                reserve-keyword
                :placeholder="$t('views.technicians.index.filters.status')"
                :remote-method="remoteMethod"
                :loading="loading">
                <el-option
                  v-for="item in statuses"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label class="form-control-label">{{ $t('views.technicians.index.filters.activeOnly') }}</label>
              <b-form-checkbox v-model="filters.activeOnly" name="check-button" switch size="lg"></b-form-checkbox>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="border-left border-dark">
        <b-row>
          <b-col>
            <b-col>
              <div class="form-group">
                <label class="form-control-label">{{ $t('views.technicians.index.filters.carRegistrationNumber') }}</label>
                <input v-model="filters.carRegistrationNumber" class="form-control" type="text" placeholder="">
              </div>
            </b-col>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row>
          <b-col>
            <div class="form-group">
              <label class="form-control-label">{{ $t('views.technicians.index.filters.businessNumber') }}</label>
              <input v-model="filters.businessNumber" class="form-control" type="text" placeholder="">
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label class="form-control-label">{{ $t('views.technicians.index.filters.name') }}</label>
              <input v-model="filters.name" class="form-control" type="text" placeholder="">
            </div>
          </b-col>
          <b-col>
            <div class="form-group">
              <label class="form-control-label">{{ $t('views.technicians.index.filters.surname') }}</label>
              <input v-model="filters.surname" class="form-control" type="text" placeholder="">
            </div>
          </b-col>
          <!--<b-col>-->
          <!--<div class="form-group">-->
          <!--<label class="form-control-label">{{ $t('views.technicians.index.filters.todayPlan') }}</label>-->
          <!--<b-form-checkbox v-model="filters.todayPlan" name="check-button" switch size="lg"></b-form-checkbox>-->
          <!--</div>-->
          <!--</b-col>-->
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'Filtering',
  data () {
    return {
      filters: {
        status: null,
        activeOnly: 1,
        businessNumber: '',
        name: '',
        surname: '',
        // todayPlan: 1,
        carRegistrationNumber: ''
      },
      statuses: [],
      loading: false
    }
  },
  methods: {
    remoteMethod () {
      // console.log()
    }
  }
}
</script>
